import hartmannLogo from "@/assets/logos/hartmann.png.asset.json";
import rudolphLogo from "@/assets/logos/rudolph-th-logo.png.asset.json";
import offergeldLogo from "@/assets/logos/offergeld.png.asset.json";
import burattiLogo from "@/assets/logos/buratti-logo.svg.asset.json";
import burattiPhoto from "@/assets/customers/buratti-truck.jpg.asset.json";
import hartmannPhoto from "@/assets/customers/hartmann-smartlane.png.asset.json";
import rudolphPhoto from "@/assets/customers/smartlane-rudolph-2.png.asset.json";
import offergeldPhoto from "@/assets/customers/offergeld-20230620.jpg.asset.json";

export type CustomerCase = {
  segment: string; customer: string; logo: string; image: string; imageAlt: string; logoPanel: boolean;
  title: string; description: string; quote: string | null; author: string | null;
  /** Optional text shown under the image; falls back to `segment`. */
  caption?: string;
  /** Hide the caption banner on the image entirely. */
  hideCaption?: boolean;
  /** Show the full photo without cropping (for portrait/square images). */
  imageFit?: "cover" | "contain";
};

// Customer facts and quotations sourced from the existing /kunden page.
export const CAMPAIGN_CUSTOMER_CASES: CustomerCase[] = [
  {
    segment: "Stückgut",
    customer: "Hartmann International",
    logo: hartmannLogo.url,
    image: hartmannPhoto.url,
    imageAlt: "Hartmann International im Einsatz mit Smartlane",
    logoPanel: false,
    title: "Komplexe Stückgutplanung. Täglich fünf Stunden Dispositionszeit eingespart.",
    description: "Bei Hartmann plant Smartlane täglich die Ein- und Ausgänge der Stückgutsendungen für mehr als 100 Fahrzeuge an zwei Standorten. Nahtlos in die bestehenden Dispositions- und Hallenprozesse sowie die TMS-Landschaft integriert, automatisiert die Lösung manuelle Planungsprozesse und entlastet die Disposition.",
    quote: "[...] Diese Entlastung führte dazu, dass wir unsere Servicequalität deutlich steigern konnten und unsere Disponenten ihren Arbeitstag nicht mehr mitten in der Nacht beginnen müssen [...].",
    author: "Uwe Lachmann · Geschäftsführer",
  },
  {
    segment: "Distribution",
    customer: "rudolph trucking & handling",
    logo: rudolphLogo.url,
    image: rudolphPhoto.url,
    imageAlt: "Smartlane und rudolph trucking & handling im gemeinsamen Austausch vor Ort",
    logoPanel: false,
    title: "Komplexe Luftfracht. Planung mit Prozessverständnis.",
    description: "rudolph t&h nutzt Smartlane für die Planung seiner Luftfrachttransporte. Dabei verbindet die Tourenplanung die besonderen Anforderungen des Luftfrachtersatzverkehrs mit den gewachsenen Abläufen der täglichen Disposition.",
    quote: "Die Kombination aus einem starken Produkt, gutem Prozessverständnis und zuverlässigem Service schafft für uns einen echten Mehrwert.",
    author: "Benedikt Wietel · Prokurist und Bereichsleiter Disposition",
  },
  {
    segment: "Filialbelieferung",
    customer: "Offergeld Logistik",
    logo: offergeldLogo.url,
    image: offergeldPhoto.url,
    imageAlt: "Offergeld Logistik – Kundenbeispiel für Tourenplanung mit Smartlane",
    logoPanel: false,
    title: "FMCG und weisse Ware. Tägliche Tourenplanung an zwei Standorten.",
    description: "Offergeld setzt Smartlane an zwei Standorten für die tägliche Tourenplanung ein – in der FMCG-Logistik und bei der Auslieferung weißer Ware. Damit unterstützt die Lösung zwei operative Einsatzbereiche.",
    quote: null,
    author: null,
  },
  {
    segment: "Großhandel",
    customer: "Buratti",
    logo: burattiLogo.url,
    image: burattiPhoto.url,
    imageAlt: "Buratti Lkw im Einsatz – Kundenbeispiel für automatisierte Tourenplanung mit Smartlane",
    logoPanel: false,
    title: "Großhandel für HoReCa. Tourenplanung, die Freiräume schafft.",
    description: "Buratti beliefert Gastronomie und Hotellerie mit italienischen Feinkostspezialitäten. Smartlane automatisiert die zuvor manuelle Tourenplanung und schafft spürbar mehr Zeit im operativen Alltag.",
    quote: "So macht der Einsatz der Software tatsächlich viel Spaß und spart mir viel Zeit in der Planung.",
    author: "Zoltán Kóbor · Disponent",
  },
];
